export default __webpack_public_path__ + "static/media/Gouri.82154d33.jpg";